export const heroData = {
  label: "LEGAL",
  title: "Specified Commercial Transactions Act Disclosure",
  subtitle:
    "The following information is provided in accordance with the Act on Specified Commercial Transactions for your peace of mind when making purchases.",
  image:
    "https://readdy.ai/api/search-image?query=Elegant%20minimal%20Japanese%20business%20document%20on%20wooden%20desk%2C%20soft%20natural%20lighting%2C%20deep%20navy%20blue%20and%20warm%20gold%20color%20tones%2C%20professional%20corporate%20atmosphere%2C%20no%20text%20visible%2C%20high%20quality%20photography&width=1920&height=600&seq=tokushohero01&orientation=landscape",
};

export const summaryText =
  "In accordance with the Act on Specified Commercial Transactions, the following information is disclosed for operators conducting internet sales. If you have any questions, please feel free to contact us via the inquiry page.";

export const sections = [
  {
    title: "Business Information",
    items: [
      { label: "Seller", value: "LUDOA Inc. (AIRDOA)" },
      { label: "Representative", value: "Representative Director [To be updated]" },
      { label: "Address", value: "7F Konotorabiru, 1-1-14 Shimomeguro, Meguro-ku, Tokyo 153-0064" },
      { label: "Phone", value: "0120-XXX-XXX (Weekdays 10:00–18:00)" },
      { label: "Email", value: "info@airdoa.jp" },
      { label: "URL", value: "https://airdoa.jp" },
    ],
  },
  {
    title: "Pricing",
    items: [
      { label: "Product price", value: "As listed on each product or course page" },
      { label: "Tax", value: "All displayed prices are tax-inclusive" },
      { label: "Additional fees", value: "No payment processing fee. Gift ticket shipping costs are charged separately at cost (e.g., letter pack)" },
      { label: "Other costs", value: "Transportation to the helipad and parking fees are the customer's responsibility" },
    ],
  },
  {
    title: "Payment Method & Timing",
    items: [
      { label: "Payment method", value: "Credit card (VISA / MasterCard / JCB / AMEX / Diners), bank transfer" },
      { label: "Credit card payment timing", value: "Payment is processed at the time the order is confirmed" },
      { label: "Bank transfer timing", value: "Please transfer within 7 days of placing your order" },
      { label: "Order validity period", value: "14 days after placing the order. Orders will be automatically cancelled if payment is not confirmed within this period" },
    ],
  },
  {
    title: "Delivery Timing",
    items: [
      { label: "Experience reservation", value: "Service is provided on the specified boarding date and time after reservation is confirmed" },
      { label: "Gift ticket (delivery)", value: "Shipped within 3–7 business days after payment is confirmed" },
      { label: "Gift ticket (digital)", value: "Sent by email within 24 hours after payment is confirmed" },
    ],
  },
  {
    title: "Returns, Cancellations & Exchanges",
    items: [
      { label: "Cancellation policy", value: "Please refer to the Cancellation Policy page. Free up to 8 days before the flight; cancellation fees apply thereafter on a sliding scale" },
      { label: "Gift ticket returns", value: "Returns accepted within 7 days of purchase for unused, unopened tickets" },
      { label: "Weather cancellations", value: "If a flight is cancelled by the operator due to weather, you may choose to reschedule or receive a full refund (no cancellation fee)" },
      { label: "Exchanges", value: "Course changes must be requested at least 7 days before the flight. Any price difference will be settled" },
    ],
  },
];

export const enactedDate = "May 1, 2026";
